import type { FunctionComponent } from "react";
import { Table, TableHeaderColumn } from "@kanda-libs/ks-component-ts";
import usePaymentTableProps from "components/payment/PaymentTable/usePaymentTableProps";
import { TABLE_COLUMNS } from "components/payment/PaymentTable/constants";

const PaymentTable: FunctionComponent = function () {
  const props = usePaymentTableProps();

  return (
    <Table
      {...props}
      columns={TABLE_COLUMNS as unknown as TableHeaderColumn[]}
    />
  );
};

export default PaymentTable;
